import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function PrivacyComponent() {
  return (
    <Container
      id="privacy"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 }
      }}>
      <Typography
        component="h1"
        variant="h4"
        color="text.primary"
        sx={{
          width: { sm: '100%', md: '80%' },
          textAlign: 'center',
          mb: 4
        }}>
        🔒 Privacy Policy
      </Typography>

      <Paper
        elevation={0}
        sx={{
          p: { xs: 3, sm: 5 },
          width: '100%',
          bgcolor: 'background.paper',
          borderRadius: 2
        }}>
        <Box sx={{ width: '100%' }}>
          {/* <Typography variant="h6" component="h2" gutterBottom>
            Introduction
          </Typography> */}
          <Typography variant="body1" paragraph>
            Last Updated: July 24, 2025
          </Typography>
          <Typography variant="body1" paragraph>
            At SCA CASES LTD, your privacy is important to us. This policy outlines how we collect,
            use, and protect your personal information.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h6" component="h2" gutterBottom>
            What We Collect
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Your name and email address (when registering or contacting us)</li>
            <li>Your case tracking data (Red/Amber/Green system)</li>
            <li>Technical data such as cookies and IP addresses (for improving site experience)</li>
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h6" component="h2" gutterBottom>
            How We Use It
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>To provide access to the platform and its features</li>
            <li>To track your learning progress</li>
            <li>To communicate updates or support, if needed</li>
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h6" component="h2" gutterBottom>
            Payment Information
          </Typography>
          <Typography variant="body1" paragraph>
            We use Stripe to process all payments securely. Stripe is a certified PCI Service
            Provider Level 1 — the most stringent level of certification. We do not store or have
            access to your full payment card details.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h6" component="h2" gutterBottom>
            Your Rights
          </Typography>
          <Typography variant="body1" paragraph>
            You have the right to request access to, correction of, or deletion of your personal
            data. Please contact us at{' '}
            <Link href="mailto:scacases@gmail.com">scacases@gmail.com</Link> with any
            privacy-related requests.
          </Typography>

          <Divider sx={{ my: 4 }} />

          <Typography variant="h6" component="h2" gutterBottom>
            Agreement
          </Typography>
          <Typography variant="body1" paragraph>
            By using this site, you agree to the terms of this privacy policy.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}
